import moment from 'moment/moment';
import React, {useEffect, useState} from 'react';
import {
   Image,
   Platform,
   ScrollView,
   StyleSheet,
   Text,
   TextInput,
   TouchableOpacity,
   View,
   ActivityIndicator,
   Keyboard,
   Alert,
   Dimensions,
} from 'react-native';
import {CopyRight} from '../../utils/CopyRight';
import {
   appBackground,
   base100,
   primaryColor500,
   white,
   FONT_FAMILY_MEDIUM,
   FONT_FAMILY_REGULAR,
   primaryColor400,
   AcceptMEssage,
   SEND_ACKNOWLEDGEMENT,
   validateEmail,
   Attestation,
   LastAttestation,
   isMobile,
   isWeb,
   appBackgroundWhiteBG,
   ActivityLoaderColor,
   isMacOS,
   hoverBtnBgColor,
   alertHandler as alertHandlers,
   profileTextBG,
} from '../../utils/utils';
import {ApplicationHeader} from '../../utils/application_header';
import {useNavigation} from '@react-navigation/native';
import KeyboardAvoidingView from '../../components/keyboard/KeyboardAvoidingView';
import {
   apiPostRequest,
   logoutHandler,
   showTokenExpireAlertWeb,
} from '../../service/network_access';
import {useDispatch, useSelector} from 'react-redux';
import {
   selectAuthData,
   setAttestation,
   setSignIn,
} from '../../redux/slices/AuthSlice';
import {selectScreenOrientation} from '../../redux/slices/ScreenOrientationSlice';
import {storeAppData} from '../../utils/preference';
import {isChrome, isTablet, isWindows} from 'react-device-detect';
import {setIsDashboardRefreshRequiredWindows} from '../../redux/slices/DashboardRefreshSlice';
import {setResponseAlertData} from '../../redux/slices/ResponseAlertSlice';
import logger from '../../utils/logger';

const AttestationProfile = () => {
   const navigation = useNavigation();
   const dispatch = useDispatch();
   const [isEmailFocused, setIsEmailFocused] = useState(false);
   const [isCompanyNameFocused, setIsCompanyNameFocused] = useState(false);
   const [isLastNameFocused, setIsLastNAmeFocused] = useState(false);
   const [isPhoneFocused, setIsPhoneFocused] = useState(false);
   const [email, setEmail] = useState('');
   const [firstName, setFirstName] = useState('');
   const [companyName, setCompanyName] = useState('');
   const [lastName, setLastName] = useState('');
   const [phoneNumber, setPhoneNumber] = useState('');
   const [norcatId, setNorcatID] = useState('');
   const isLandscapemode = useSelector(selectScreenOrientation);
   const [isApiLoading, setIsApiLoading] = useState(false);
   const userAgent = isWeb ? window.navigator.userAgent : null;
   const isPadChromeBrowser = userAgent?.includes('iPad') && isChrome;
   const iPhoneBrowser = userAgent?.includes('iPhone OS');
   const [isHover, setHover] = React.useState(false);
   const [btnHover, setBtnHover] = React.useState(false);
   // const [authData, setAuthData] = useState({});
   // const authData = useSelector(selectAuthData);
   const authData = useSelector(selectAuthData);
   const [isKeyboardVisible, setKeyboardVisible] = useState(false);
   const disPatch = useDispatch();
   const [dataChanged, setDataChanged] = useState(false);

   useEffect(() => {
      (async () => {
         // const authData = await retrieveAppData(AUTHDATA);
         // const data = JSON.parse(authData);
         logger(authData.EmailAddress, false);
         setFirstName(authData.FirstName);
         setLastName(authData.LastName);
         setPhoneNumber(decodeURIComponent(authData.PhoneNumber));
         setCompanyName(authData.CompanyName);
         setEmail(authData.EmailAddress);
         setNorcatID(authData.NORCAT_ID);
         // setAuthData(data);
      })();
      const keyboardWillShowListener = Keyboard.addListener(
         Platform.OS === 'android' ? 'keyboardDidShow' : 'keyboardWillShow',
         () => {
            setKeyboardVisible(true);
         },
      );

      const keyboardDidHideListener = Keyboard.addListener(
         'keyboardDidHide',
         () => {
            setKeyboardVisible(false);
         },
      );

      return () => {
         keyboardWillShowListener.remove();
         keyboardDidHideListener.remove();
      };
   }, []);

   const emailHandleFocus = () => {
      setIsEmailFocused(true);
   };

   const companyNameHandleFocus = () => {
      setIsCompanyNameFocused(true);
   };

   const phoneHandleFocus = () => {
      setIsPhoneFocused(true);
   };

   const emailHandleBlur = () => {
      setIsEmailFocused(false);
   };

   const companyNameHandleBlur = () => {
      setIsCompanyNameFocused(false);
   };

   const phoneHandleBlur = () => {
      setIsPhoneFocused(false);
   };

   // const borderEmailStyle = {
   //    borderTopWidth: isEmailFocused ? 0 : 1,
   //    borderRightWidth: isEmailFocused ? 0 : 1,
   //    borderLeftWidth: isEmailFocused ? 0 : 1,
   //    borderBottomWidth: isEmailFocused ? 3 : 1,
   //    borderColor: '#AFBACA',
   //    borderRadius: isEmailFocused ? 0 : 6,
   // };

   // const borderCompanyNameStyle = {
   //    borderTopWidth: isCompanyNameFocused ? 0 : 1,
   //    borderRightWidth: isCompanyNameFocused ? 0 : 1,
   //    borderLeftWidth: isCompanyNameFocused ? 0 : 1,
   //    borderBottomWidth: isCompanyNameFocused ? 3 : 1,
   //    borderColor: '#AFBACA',
   //    borderRadius: isCompanyNameFocused ? 0 : 6,
   // };

   // const borderPhoneStyle = {
   //    borderTopWidth: isPhoneFocused ? 0 : 1,
   //    borderRightWidth: isPhoneFocused ? 0 : 1,
   //    borderLeftWidth: isPhoneFocused ? 0 : 1,
   //    borderBottomWidth: isPhoneFocused ? 3 : 1,
   //    borderColor: '#AFBACA',
   //    borderRadius: isPhoneFocused ? 0 : 6,
   // };

   const handlePhoneNumberChange = text => {
      // Remove all non-numeric characters from the input
      const formattedPhoneNumber = text.replace(/[^0-9()+-]/g, '');

      // Format the phone number with parentheses and dashes
      // if (formattedPhoneNumber.length === 10) {
      //   const formattedText = `(${formattedPhoneNumber.slice(
      //     0,
      //     3,
      //   )}) ${formattedPhoneNumber.slice(3, 6)}-${formattedPhoneNumber.slice(6)}`;
      //   setPhoneNumber(formattedText);
      // } else {
      setDataChanged(true);
      setPhoneNumber(formattedPhoneNumber);
      // }
   };

   return (
      <KeyboardAvoidingView
         behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
         style={styles.container}>
         <View style={styles.container}>
            <ApplicationHeader
               OnBackPress={() => {
                  const user = {
                     isLoggedIn: false,
                     userName: '',
                  };
                  Platform.OS === 'web'
                     ? logoutHandler()
                     : dispatch(setSignIn(user));
                  //navigation.goBack();
               }}
               title="Please Verify: User Profile"
            />
            <View style={styles.headerTopBackground}>
               <Image
                  source={require('../../assets/userIcon.png')}
                  style={{width: 14, height: 14, tintColor: white}}
               />
               <Text
                  style={{
                     flex: 1,
                     textAlignVertical: 'center',
                     color: white,
                     fontSize: 14,
                     marginLeft: 10,
                     fontWeight: '500',
                     fontFamily: FONT_FAMILY_REGULAR,
                  }}>
                  Account Details
               </Text>
            </View>
            <View
               style={{
                  alignItems: 'center',
                  flex: 1,
               }}>
               <ScrollView
                  style={{
                     width: isLandscapemode ? '40%' : '100%',
                     paddingHorizontal: 15,
                     flexGrow: 0,
                     ...Platform.select({
                        web: {
                           marginBottom: !isLandscapemode ? 200 : null,
                        },
                        ios: {
                           zindex: 100,
                        },
                        macos: {
                           paddingHorizontal: null,
                        },
                        windows: {
                           paddingHorizontal: 10,
                        },
                     }),
                  }}>
                  <View>
                     <Text style={styles.titleStyle}>NORCAT ID</Text>

                     <View style={[styles.inputStyle]}>
                        <Text style={styles.textStyle}>{norcatId}</Text>
                     </View>
                     <Text style={styles.titleStyle}>First Name</Text>
                     <View style={[styles.inputStyle]}>
                        <Text style={styles.textStyle}>{firstName}</Text>
                     </View>
                     <Text style={styles.titleStyle}>Last Name</Text>
                     <View style={[styles.inputStyle]}>
                        <Text style={styles.textStyle}>{lastName}</Text>
                     </View>
                     <Text style={styles.titleStyle}>Email Address</Text>
                     <View style={[styles.inputStyle]}>
                        <TextInput
                           style={[
                              styles.textStyle,
                              {
                                 opacity: 1,
                                 maxHeight:
                                    Platform.OS === 'windows'
                                       ? null
                                       : !isMobile
                                       ? 20
                                       : null,
                              },
                           ]}
                           value={email}
                           maxLength={50}
                           onChangeText={text => {
                              if (text.length <= 50) {
                                 setEmail(text);
                              }
                              setDataChanged(true);
                           }}
                           onFocus={emailHandleFocus}
                           onBlur={emailHandleBlur}
                        />
                     </View>

                     <Text style={styles.titleStyle}>Phone Number</Text>
                     <View style={[styles.inputStyle]}>
                        <TextInput
                           style={[
                              styles.textStyle,
                              {
                                 opacity: 1,
                                 maxHeight:
                                    Platform.OS === 'windows'
                                       ? null
                                       : !isMobile
                                       ? 20
                                       : null,
                              },
                           ]}
                           onFocus={phoneHandleFocus}
                           onBlur={phoneHandleBlur}
                           maxLength={25}
                           keyboardType="phone-pad"
                           onChangeText={handlePhoneNumberChange}
                           value={phoneNumber}
                        />
                     </View>
                     <Text style={styles.titleStyle}>Company</Text>
                     <View style={[styles.inputStyle]}>
                        <TextInput
                           style={[
                              styles.textStyle,
                              {
                                 opacity: 1,
                                 maxHeight:
                                    Platform.OS === 'windows'
                                       ? null
                                       : !isMobile
                                       ? 20
                                       : null,
                              },
                           ]}
                           value={companyName}
                           onFocus={companyNameHandleFocus}
                           onChangeText={text => {
                              setCompanyName(text);
                              setDataChanged(true);
                           }}
                           onBlur={companyNameHandleBlur}
                        />
                     </View>
                  </View>
               </ScrollView>
               <Text
                  style={{
                     fontSize: 12,
                     fontWeight: '400',
                     fontFamily: FONT_FAMILY_REGULAR,
                     color: 'black',
                     paddingHorizontal:
                        Platform.OS === 'windows'
                           ? null
                           : isLandscapemode
                           ? '30%'
                           : 16,
                     paddingTop: 15,
                     paddingBottom: 10,
                     width: Platform.OS === 'windows' ? '40%' : '100%',
                     letterSpacing: 1,
                     textAlign: isLandscapemode ? 'justify' : 'center',
                     ...Platform.select({
                        web: {
                           // height: isLandscapemode
                           //    ? isTablet
                           //       ? '25%'
                           //       : '30%'
                           //    : (isPadChromeBrowser || iPhoneBrowser) &&
                           //      isLandscapemode == false
                           //    ? '20%'
                           //    : '35%',
                           paddingRight: 30,
                           paddingHorizontal: null,
                           paddingLeft: 16,
                           paddingTop: isTablet || !isLandscapemode ? 15 : 24,
                           width: isLandscapemode ? '40%' : '100%',
                           position: isLandscapemode ? null : 'fixed',
                           bottom: isLandscapemode ? null : 100,
                           backgroundColor: isLandscapemode
                              ? null
                              : appBackgroundWhiteBG,
                        },
                        macos: {
                           paddingHorizontal: null,
                           paddingRight: 20,
                           paddingLeft: 0,
                           width: isLandscapemode ? '40%' : '100%',
                        },
                        ios: {
                           // height: isLandscapemode ? '15%' : null,
                           paddingHorizontal: 16,
                           width: isLandscapemode ? '40%' : '100%',
                           backgroundColor: 'white',
                        },
                        android: {
                           paddingHorizontal: 16,
                           width: isLandscapemode ? '40%' : '100%',
                        },
                        windows: {
                           paddingRight: 20,
                        },
                     }),
                  }}>
                  {AcceptMEssage}
               </Text>
            </View>
            {
               <View
                  style={{
                     width: '100%',
                     ...Platform.select({
                        web: {
                           marginBottom: 25,
                           position: isLandscapemode ? null : 'fixed',
                           bottom: isLandscapemode ? null : 0,
                        },
                     }),
                  }}>
                  <TouchableOpacity
                     style={{
                        backgroundColor: btnHover
                           ? hoverBtnBgColor
                           : primaryColor500,
                        minHeight: 48,
                        marginVertical: isLandscapemode ? 5 : 20,
                        marginHorizontal: 16,
                        borderRadius: 6,
                        width: isLandscapemode ? 150 : '90%',
                        justifyContent: 'center',
                        alignSelf: 'center',
                        ...Platform.select({
                           web: {
                              marginVertical: 10,
                           },
                        }),
                     }}
                     onMouseEnter={() => {
                        setBtnHover(true);
                     }}
                     onMouseLeave={() => {
                        setBtnHover(false);
                     }}
                     onPress={() => {
                        if (dataChanged) {
                           logger(
                              'Sending updated profile data to server',
                              true,
                           );
                           UpdateUserProfile();
                        } else {
                           logger('No New Data', true);
                           navigation.navigate('DashboardScreen');
                        }
                     }}>
                     <View
                        style={{
                           flexDirection: 'row',
                           justifyContent: 'center',
                           alignContent: 'center',
                           alignItems: 'center',
                        }}>
                        <Text
                           style={{
                              color: 'white',
                              fontSize: 16,
                              fontWeight: '500',
                              textAlign: 'center',
                              fontFamily: FONT_FAMILY_MEDIUM,
                           }}>
                           Accept
                        </Text>
                        <Image
                           source={require('../../assets/double_tick.png')}
                           style={{
                              marginStart: 10,
                              width: 17,
                              height: 10,
                           }}
                        />
                     </View>
                  </TouchableOpacity>
               </View>
            }
            {isLandscapemode && (
               <View
                  style={{
                     position: isWeb ? 'fixed' : 'relative',
                     height: 40,
                     bottom: 0,
                     left: 0,
                     right: 0,
                     paddingTop: 4,
                     paddingBottom: 6,
                     backgroundColor: appBackgroundWhiteBG,
                  }}>
                  <CopyRight
                     screenOrientation={isLandscapemode}
                     isCopyrightShown={!isKeyboardVisible}
                  />
               </View>
            )}
            {isApiLoading && (
               <View
                  style={{
                     width: '100%',
                     height: '100%',
                     justifyContent: 'center',
                     alignItems: 'center',
                     position: 'absolute',
                     //backgroundColor: 'red',
                     //opacity: 0.4,
                     //bottom: 75,
                     //top: 0,
                  }}>
                  <ActivityIndicator size="large" color={ActivityLoaderColor} />
               </View>
            )}
         </View>
      </KeyboardAvoidingView>
   );

   function UpdateUserProfile() {
      if (Platform.OS === 'windows') {
         dispatch(setIsDashboardRefreshRequiredWindows(true));
      }
      if (!email.trim()) {
         alertHandler('Please enter email.', 'NO_BACK');
         return;
      }

      if (!validateEmail(email)) {
         alertHandler('Please enter valid email.', 'NO_BACK');
         return;
      }

      if (!phoneNumber.trim()) {
         alertHandler('Please enter phone number.', 'NO_BACK');
         return;
      }

      if (phoneNumber.length > 25) {
         alertHandler('Please enter valid phone number.', 'NO_BACK');
         return;
      }

      if (!companyName.trim()) {
         alertHandler('Please enter company name.', 'NO_BACK');
         return;
      }
      setIsApiLoading(true);
      const reqParms = {
         theData: JSON.stringify({
            EmployeeKey: authData.EmployeeKey,
            NORCATID: norcatId,
            FirstName: firstName,
            LastName: lastName,
            PhoneNumber: encodeURIComponent(phoneNumber),
            Email: email,
            CompanyName: companyName,
            DistributionName: authData.DistributionName,
         }),
      };
      setIsApiLoading(true);
      apiPostRequest({url: SEND_ACKNOWLEDGEMENT, parms: reqParms})
         .then(res => {
            setIsApiLoading(false);
            // setIsApiLoading(false);
            if (res && res.StatusResult) {
               logger('Success Response:: ' + res, false);
               // const user = {
               //   isLoggedIn: true,
               //   userName: res.ACMEmployeeFirstName,
               // };

               // alert(res.StatusMessage);
               // dispatch(setSignIn(user));
               if (Platform.OS === 'web') {
                  dispatch(setAttestation(true));
                  storeAppData(Attestation, true);
                  storeAppData(LastAttestation, Date.now());
               }
               navigation.navigate('DashboardScreen');
            } else if (typeof res === 'string') {
               logger('Exception Response:: ' + res, false);
               // setIsError(true);
               // setErrorMessage(res);
               if (isWeb) {
                  showTokenExpireAlertWeb(res);
               } else {
                  alert(res);
               }
            } else {
               logger('Error Response:: ' + JSON.stringify(res), false);
               // setIsError(true);
               // setErrorMessage('Please verify your login credential');
            }
         })
         .catch(err => logger({err}, false));
   }
   function alertHandler(message, callbackType = 'GO_BACK') {
      if (isWeb) {
         alertHandlers(dispatch, setResponseAlertData, message, callbackType);
      } else {
         alert(message);
      }
   }
};

function formateDate(date) {
   return moment(date).format('DD-MM-YYYY');
}

const styles = StyleSheet.create({
   container: {
      backgroundColor: white,
      flex: 1,
      ...Platform.select({
         web: {
            flex: null,
            height: 64,
            minHeight: '100vh',
            paddingBottom: 10,
         },
      }),
   },
   inputStyle: {
      width: '100%',
      height: 48,
      backgroundColor: '#F3F3F3',
      marginTop: 8,
      borderWidth: 0,
      paddingHorizontal: 14,
      borderColor: '#F3F3F3',
      justifyContent: 'center',
      borderRadius: 6,
      fontSize: 14,
      maxHeight: 48,
      textAlignVertical: 'center',
      color: base100,
      fontWeight: '700',
      fontFamily: FONT_FAMILY_REGULAR,
   },

   headerTopBackground: {
      backgroundColor: '#001231',
      paddingHorizontal: 16,
      paddingVertical: 10,
      flexDirection: 'row',
      alignItems: 'center',
   },
   titleStyle: {
      fontSize: 14,
      marginTop: 16,
      color: '#000000',
      fontWeight: '600',
      fontFamily: FONT_FAMILY_REGULAR,
   },
   profileStyle: {
      paddingHorizontal: 16,
      flexDirection: 'column',
   },
   profileStyleLandscap: {
      paddingHorizontal: 16,
      paddingVertical: 8,
      flexDirection: 'row',
   },
   textStyle: {
      paddingStart: 0,
      backgroundColor: '#00000000',
      borderWidth: 0,
      color: base100,
      opacity: 0.6,
      padding: Platform.OS === 'windows' ? 10 : 0,
      borderRadius: 6,
      borderColor: profileTextBG,
      fontWeight: '700',
      fontFamily: FONT_FAMILY_REGULAR,
      textAlignVertical: 'center',
   },

   overlay: {
      ...StyleSheet.absoluteFillObject,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      justifyContent: 'center',
      alignItems: 'center',
   },
   datePicker: {
      backgroundColor: 'rgba(255, 255, 255, 0.8)',
      color: '#000',
   },
});

export default AttestationProfile;
